export const REDUCER_NAME = 'FilesGrid'

export const types = {
  clients: 'clients',
  collaterals: 'collaterals',
  loans: 'loans',
}

export const actions = {
  FETCH: 'FilesGrid/FETCH',
  FETCH_SUCCESS: 'FilesGrid/FETCH_SUCCESS',
  FETCH_FAILURE: 'FilesGrid/FETCH_FAILURE',
}

export const factoryActions = {
  INITIALIZE: 'Files/INITIALIZE',
  INITIALIZE_TYPE: 'Files/INITIALIZE_TYPE',
}
